import { me } from '../../core/selectors.js';
import { S } from '../../core/store.js';
import { addDays, daysTo, off, pd, weekStartIso } from '../../core/util.js';
import { shiftHrs } from '../roster/model.js';
import { STAGES } from '../sales/model.js';

export const SUPER=.12,ONCOST=.03;

export const staff=()=>S.users.filter(u=>u.active&&S.hr[u.id]);

export function monthlyCost(id){const h=S.hr[id];if(!h)return 0;
  if(h.basis==='salary')return h.rate*(h.fte||1)/12*(1+SUPER+ONCOST);
  if(h.basis==='hourly')return h.rate*(h.hrs||0)*52/12*(1+SUPER+ONCOST);
  if(h.basis==='day')return h.rate*(h.days||0);return 0}

export function hourCost(id){const h=S.hr[id];if(!h)return 0;
  if(h.basis==='salary')return h.rate/(52*38)*(1+SUPER+ONCOST);
  if(h.basis==='hourly')return h.rate*(1+SUPER+ONCOST);
  if(h.basis==='day')return h.rate/8;return 0}

export function fortnightWages(){return staff().reduce((a,u)=>{const h=S.hr[u.id];if(h.basis==='salary')return a+h.rate*(h.fte||1)/26;if(h.basis==='hourly')return a+h.rate*(h.hrs||0)*2;return a},0)}

export function forecast(){
  const F=S.fin,N=13;const rows=Array.from({length:N},(_,i)=>({i,from:off(7*i),inv:0,quote:0,pipe:0,nw:0,pay:0,sup:0,contr:0,fix:0,ads:0,bas:0,rent:0,in:0,out:0,close:0}));
  const wk=iso=>{const n=daysTo(iso);return n<0?0:Math.floor(n/7)};
  S.docs.filter(d=>d.type==='invoice'&&['Sent','Overdue'].includes(d.status)).forEach(d=>{const exp=d.status==='Overdue'?off(7):off(Math.max(0,daysTo(d.due))+F.delay);const w=wk(exp);if(w<N)rows[w].inv+=d.amt});
  S.docs.filter(d=>d.type==='quote'&&d.status==='Accepted'&&!S.docs.some(i=>i.type==='invoice'&&i.client===d.client)).forEach(d=>{rows[Math.min(2,N-1)].quote+=d.amt/2;rows[Math.min(8,N-1)].quote+=d.amt/2});
  if(F.incPipeline)S.deals.filter(d=>!['won','lost','hold','lead'].includes(d.stage)).forEach(d=>{const s=STAGES.find(x=>x.id===d.stage);const w=wk(off(daysTo(d.close)+S.settings.terms));if(w<N)rows[w].pipe+=d.amt*(s?s.w:0)});
  rows.forEach(r=>{if(r.i>=3)r.nw=F.newWork/4.33});
  const fw=fortnightWages();for(let k=0;k<N;k+=2){const w=wk(off(daysTo(F.nextPay)+7*k));if(w<N)rows[w].pay+=fw}
  const monthlyWages=fw*26/12;const wk1=wk(off(7));rows[Math.min(wk1,N-1)].sup+=monthlyWages*3*SUPER;
  const contr=staff().filter(u=>S.hr[u.id].basis==='day').reduce((a,u)=>a+monthlyCost(u.id),0);
  const fixed=(F.software+F.insurance+F.accountant+F.gear+F.other)/4.33;const ads=S.mkt.camps.reduce((a,c)=>a+c.spend,0)/4.33;
  rows.forEach(r=>{r.contr=contr/4.33;r.fix=fixed;r.ads=ads;const d0=pd(r.from);for(let k=0;k<7;k++){const d=new Date(d0);d.setDate(d.getDate()+k);if(d.getDate()===1)r.rent+=F.rent}});
  rows[wk(F.basDue)<N?wk(F.basDue):N-1].bas+=F.basAmt;
  let bal=F.cash;rows.forEach(r=>{r.in=r.inv+r.quote+r.pipe+r.nw;r.out=r.pay+r.sup+r.contr+r.fix+r.ads+r.bas+r.rent;bal+=r.in-r.out;r.close=bal});
  const low=rows.reduce((a,r)=>r.close<a.close?r:a,rows[0]);return {rows,low,end:rows[N-1].close};
}

export function utilWeek(id){const mon=weekStartIso(0);const sh=S.roster.shifts.filter(s=>s.uid===id&&s.pid&&['shoot','edit'].includes(s.type)&&s.date>=mon&&s.date<=addDays(mon,6));return sh.reduce((a,s)=>a+shiftHrs(s),0)}

export function projLabour(){const out={};S.roster.shifts.forEach(s=>{if(!s.pid)return;out[s.pid]=(out[s.pid]||0)+shiftHrs(s)*hourCost(s.uid);});return out}


